import React, { useState } from "react";
import QRCode from "react-qr-code";
import { useLang } from "../utils/LangContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";

const GameQRCodeModal = ({ code = "aaabbb" }) => {
  const { t } = useLang();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Icon button to open modal */}
      <button
        onClick={() => setIsOpen(true)}
        className="btn btn-info flex items-center justify-center bg-blue-600 text-white rounded-full shadow-md hover:bg-blue-700"
        aria-label={t('Show QR Code')}
      >
        <FontAwesomeIcon icon={faQrcode} size="lg" />
      </button>

      {/* Modal overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-lg font-bold mb-4">{t("Scan game code")}</h2>
            <QRCode value={code} size={200} />
            <p className="mt-2 text-sm text-gray-600">{code}</p>

            {/* Close Button */}
            <button
              onClick={() => setIsOpen(false)}
              className="btn btn-warning mb-2 rounded-lg hover:bg-red-600"
            >
              {t('Close')}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default GameQRCodeModal;
